import { Button, Form, Space, Select, Cascader } from 'antd';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SCHEDULE_TYPE_LIST } from '../../../constants';

/**
 * Cascader 搜索过滤：路径中任意节点 label 包含关键字即匹配。
 */
const filterHallCascader = (inputValue, path) => path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

/**
 * 本机构在日程展示 - 单行可拖拽排序项
 * 使用 @dnd-kit/sortable 实现，替代已废弃的 react-sortable-hoc（避免 findDOMNode 警告）。
 * @param {Object}   props.id                 dnd-kit 唯一标识（field.key）
 * @param {Object}   props.field              Form.List 提供的 field 对象
 * @param {Array}    props.conferenceHallList  会场级联选项
 * @param {Function} props.onDelete           删除当前行回调 (fieldName)
 */
export default function HallScheduleSortableItem({ id, field, conferenceHallList, onDelete }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={style} className="schedule-display-item">
            <span className="schedule-display-item-no">{field.name + 1}</span>
            <Space style={{ display: 'flex' }} align="center">
                <Button type="link" {...listeners} {...attributes} style={{ cursor: 'grab', padding: 0 }}>
                    <i className="bi bi-grip-vertical" />
                </Button>
                <Form.Item name={[field.name, 'sponsorType']} rules={[{ required: true, message: '请选择机构类型' }]}>
                    <Select placeholder="机构类型" style={{ width: 120 }} options={SCHEDULE_TYPE_LIST} classNames={{ popup: { root: 'first-conference' } }} fieldNames={{ value: 'id', label: 'name' }} />
                </Form.Item>
                <Form.Item name={[field.name, 'hallId']} rules={[{ required: true, message: '选择会议名称' }]}>
                    <Cascader style={{ width: 500 }} options={conferenceHallList} showSearch={{ filter: filterHallCascader }} changeOnSelect />
                </Form.Item>
                <span className="anticon" onClick={() => onDelete(field.name)}>
                    <i className="bi bi-dash-circle" />
                </span>
            </Space>
        </div>
    );
}
